import htmlElements from "./htmlElements";

const validation = {
    validNameCases(type, value) {
        //Set boolean variable
        var isValidName = false;

        switch (type) {
            //Only Letters and special char
            case 1:
                isValidName = /^[A-Z-a-z-À-ü( )\ç\s]+$/gm.test(value);
                break;

            //Only Numbers, white space and hífen
            case 2:
                isValidName = /^[0-9( )\s\-]+$/gm.test(value);
                break;

            //Only Letters, white space, special char (ç) and comma
            case 3:
                isValidName = /^[A-Z-a-z-À-ü( )\,\ç\s]+$/gm.test(value);
                break;

            //Only Letters, numbers, white space and special chars
            case 4:
                isValidName =
                    /^[0-9-A-Z-a-z-À-ü( )/\-\.\º\"\'\:\,\ç\&\s\!\?\;]+$/gm.test(
                        value,
                    );
                break;

            //Only Letters, Numbers and White Space
            case 5:
                isValidName = /^[0-9-A-Z-a-z( )]+$/gm.test(value);
                break;

            //Only Letters, numbers, white space, special chars and html tags
            case 6:
                isValidName =
                    /^[0-9-A-Z-a-z-À-ü( )/\-\.\º\"\'\:\,\ç\&\s\<\>\</\!\_]+$/gm.test(
                        value,
                    );
                break;

            //Email Validation
            case 7:
                let emailRegex = new RegExp(
                    /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/,
                    "gm",
                );
                isValidName = emailRegex.test(value);

                break;

            //URL Validation
            case 8:
                isValidName = this.isValidUrl(value);
                break;

            //Date Validation
            case 9:
                isValidName = /^[0-9( )\s\-\/\:]+$/gm.test(value);
                break;

            //File routine validation
            case 10:
                isValidName = /^[0-9-A-Z-a-z-À-ü( )/\-\_\ç\&\s]+$/gm.test(
                    value,
                );
                break;

            //Password Validation (letters, numbers and special char)
            case 11:
                isValidName = /^[0-9-A-Z-a-z-À-ü/\-\_\ç\&\*\#\-\@]+$/gm.test(
                    value,
                );
                break;

            //Only Numbers
            case 12:
                isValidName = /^[0-9\s]+$/gm.test(value);
                break;

            //Only Decimal Numbers
            case 13:
                isValidName = /^[0-9\s\.]+$/gm.test(value);
                break;

            //Only for Hour Value
            case 14:
                isValidName = /^[0-9\s\:]+$/gm.test(value);
                break;

            //Only Letters and Numbers
            case 15:
                isValidName = /^[0-9-A-Z-a-z]+$/gm.test(value);
                break;

            //Only Letters, numbers, white space and special char (ç)
            default:
                //Check Element
                isValidName = /^[0-9-A-Z-a-z-À-ü( )\ç\s]+$/gm.test(value);
                break;
        }

        return isValidName;
    },
    isValidUrl(string) {
        try {
            //Validate the url
            new URL(string);

            return true;
        } catch (err) {
            return false;
        }
    },
    createErrorMessageElement(idname, errorMessage, removespan = 5000) {
        //Check when span exist
        if (!document.querySelector("span.errorMessage")) {
            //Get Element to Apeend
            let input = document.getElementById(idname);

            //Add Error Message Class for the input
            input.classList.add("is-invalid");

            //Create Element
            let spanError = document.createElement("span");

            //Set Attribute for the element
            spanError.setAttribute(
                "class",
                "errorMessage order-3 invalid-feedback",
            );
            spanError.innerText = errorMessage;

            //Create Element After Input
            input.after(spanError);

            //Remove Span Element
            setTimeout(() => {
                //Remove ErrorMessage class from the input
                input.classList.remove("is-invalid");

                //Remove Span Error Message
                document.querySelector("span.errorMessage").remove();
            }, removespan);

            return;
        }

        return;
    },
    isValidNif(value) {
        //List of invalid NIFS
        let invalidNifs = [
            111111111, 222222222, 333333333, 444444444, 555555555, 666666666,
            777777777, 888888888, 999999999, 123456789, 987654321, 147852369,
        ];

        //Check Nif Structure
        if (!invalidNifs.includes(parseInt(value))) {
            //true indicate the nif is valid but need to disabled the button
            return this.validNifStructure(parseInt(value)) ? false : true;
        }

        return invalidNifs.includes(parseInt(value));
    },
    validNifStructure(nif) {
        //Fórmula do Módulo 11
        //Base Values
        let nifvalidation = {
            numberWeight: [9, 8, 7, 6, 5, 4, 3, 2],
            numberNif: nif.toString().split(""),
            baseNumber: [],
        };

        // Prefixos oficiais válidos
        const prefixosValidos = [
            "1",
            "2",
            "3", // Pessoas singulares
            "5", // Pessoas coletivas
            "6", // Administração Pública
            "8", // Empresários em nome individual (antigos)
            "9", // NIFs provisórios / não residentes
        ];

        // Verificar prefixo
        if (!prefixosValidos.includes(nifvalidation.numberNif[0])) {
            return false;
        }

        //Preserve the Last Number
        let lastNumber = nifvalidation.numberNif.pop();

        //Transform string to integer
        let i = 0;

        do {
            let number =
                parseInt(nifvalidation.numberNif[i], 10) *
                nifvalidation.numberWeight[i];
            nifvalidation.baseNumber.push(number);
            i++;
        } while (i < nifvalidation.numberNif.length);

        //Plus all value
        nifvalidation.baseNumber = nifvalidation.baseNumber.reduce(
            (total, value) => total + value,
            0,
        );

        //Get the rest from divide the baseNumber by 11
        let divideRest = nifvalidation.baseNumber % 11;

        //Check the rest value number
        let controlNumber = divideRest < 2 ? 0 : 11 - divideRest;

        //Check the last number is equal the control number
        return parseInt(lastNumber, 10) === controlNumber;
    },
    confirmPassword(password) {
        //Check password structure
        let patterns = this.confirmPasswordPatterns();

        //Confirm Patterns Types
        let confirmTypes = [];

        //Check Routine
        patterns.forEach((value) => {
            switch (value.type) {
                case "uppercase":
                case "lowercase":
                case "number":
                case "symbol":
                    password.split("").forEach((valpass) => {
                        value.check = value.pattern.test(valpass);

                        //Set Message for indicate Check
                        if (value.check) {
                            confirmTypes.push(value.type);
                        }
                    });

                    break;

                case "length":
                    value.check = password.length <= value.pattern;

                    if (!value.check) {
                        confirmTypes.push(value.type);
                    }

                    break;
            }
        });

        //Get Only Unique Values
        confirmTypes = [...new Set(confirmTypes)];

        let typedata = [];

        //Append Confirm Password Element
        confirmTypes.forEach((value) => {
            let typepattern = patterns.find(
                (valtype) => valtype.type === value,
            );

            if (typedata.length === 0) {
                typedata.push(typepattern);
            } else {
                let confirmpush = typedata.find((valtype) =>
                    Object.is(valtype.type, typepattern.type),
                );

                if (confirmpush === undefined) {
                    typedata.push(typepattern);
                }
            }
        });

        return typedata;
    },
    confirmPasswordElementStructure(type, action, elementbase) {
        //Div Wrapper
        let divwrapper = htmlElements.createElement("div", {
            class: "check-password-wrapper",
            data_type: type,
        });

        //Span Element
        let span = htmlElements.createElement(
            "span",
            {
                data_type: type,
                class: "check-password-type",
            },
            action,
        );

        //Image Element
        /* let img = htmlElements.createElement('img', {
            src: `${window.location.origin}/images/icons/confirmpassword/check.svg`,
            alt: 'Confirm Password Icon'
        }); */

        //Append Children
        divwrapper.appendChild(span);
        //divwrapper.appendChild(img);

        document.getElementById(`${elementbase}`).appendChild(divwrapper);
    },
    confirmPasswordRoutine(elementbase, typedata) {
        typedata.forEach((value) => {
            if (
                [...document.getElementById(`${elementbase}`).children]
                    .length === 0
            ) {
                //Create Element
                this.confirmPasswordElementStructure(
                    value.type,
                    value.action,
                    elementbase,
                );
            } else {
                //Check Type for Append New Element
                let confirmAppend = [
                    ...document.getElementById(`${elementbase}`).children,
                ].find(
                    (valcheck) =>
                        valcheck.getAttribute("data-type") === value.type,
                );

                if (confirmAppend === undefined) {
                    this.confirmPasswordElementStructure(
                        value.type,
                        value.action,
                        elementbase,
                    );
                }
            }
        });
    },
    confirmPasswordPatterns() {
        return [
            {
                type: "uppercase",
                pattern: /^[A-Z-À-Ü\ç]+$/gm,
                action: "Letra Maiúscula",
                check: false,
            },
            {
                type: "lowercase",
                pattern: /^[a-z-à-ü\ç]+$/gm,
                action: "Letra Minúscula",
                check: false,
            },
            {
                type: "number",
                pattern: /^[0-9]+$/gm,
                action: "Número",
                check: false,
            },
            {
                type: "symbol",
                pattern: /^[\-\.\º\ª\:\,\&\;\*\#\,\@\_]+$/gm,
                action: "Caracter Especial",
                check: false,
            },
            {
                type: "length",
                pattern: 8,
                action: "Mínimo de Caracteres",
                check: true,
            },
        ];
    },
    confirmPasswordAddIcon(elementbase, typedata) {
        //Add Icon
        [...document.getElementById(`${elementbase}`).children].forEach(
            (value) => {
                let checkelement = typedata.find(
                    (valcheck) =>
                        valcheck.type === value.getAttribute("data-type"),
                );

                if (
                    checkelement !== undefined &&
                    [...value.children].length === 1
                ) {
                    //Image Element
                    let img = htmlElements.createElement("img", {
                        class: "check-password-icon",
                        src: `${window.location.origin}/images/icons/confirmpassword/check.svg`,
                        alt: "Confirm Password Icon",
                    });

                    //Append Element
                    value.firstElementChild.after(img);
                }
            },
        );
    },
};

export default validation;
